const constants = () => {
  const BELOW_BANNER_KEY = "below_banner"
  const BELOW_BANNER_LABEL = "Below banner"
  const ABOVE_FOOTER_KEY = "above_footer"
  const ABOVE_FOOTER_LABEL = "Above footer"
  const BUFFER = Math.pow(2, 16)
  const SIDE_BY_SIDE = "sideBySide"
  const PROMOTION = "promotion"
  const POSITION_LABEL_HELPER_WORD = "slot"

  const DEFAULT_POSITION = {
    value: BUFFER,
    location: BELOW_BANNER_KEY,
    label: `${BELOW_BANNER_LABEL} ${POSITION_LABEL_HELPER_WORD} 1`
  }

  const POSITION_KEY_LABEL = {
    [BELOW_BANNER_KEY]: BELOW_BANNER_LABEL,
    [ABOVE_FOOTER_KEY]: ABOVE_FOOTER_LABEL
  }

  return {
    BELOW_BANNER_LABEL, BELOW_BANNER_KEY, ABOVE_FOOTER_LABEL, ABOVE_FOOTER_KEY,
    BUFFER, SIDE_BY_SIDE, PROMOTION, DEFAULT_POSITION, POSITION_KEY_LABEL,
    POSITION_LABEL_HELPER_WORD
  }
}

module.exports = constants()


